import { render, staticRenderFns } from "./FieldPlaceholder.vue?vue&type=template&id=19a910c6&"
import script from "./FieldPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FieldPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports